export const PROMOTION_SIDEBAR_SECTION = "Promotion & Levels";

export const SETTING_SIDEBAR_SECTIONS = [
  {
    label: "Homepage",
    items: [
      { label: "Calendar", linkId: "M3", link: "/management/calendarEvent" },
      {
        label: "Consultant Incentive",
        linkId: "M9",
        link: "/management/consultantIncentive",
      },
      {
        label: "Client Promotion",
        linkId: "M5",
        link: "/management/clientPromotion",
      },
      { label: "Top Rankings", linkId: "M17", link: "/management/topRanking" },
    ],
  },
  {
    label: "Products",
    items: [
      {
        label: "Product Category",
        linkId: "M8",
        link: "/operation/productCategory",
      },
      {
        label: "Product Type Group",
        linkId: "O16",
        link: "/operation/productTypeGroup",
      },
      { label: "Product Type", linkId: "M10", link: "/operation/productType" },
      {
        label: "Product Provider",
        linkId: "O6",
        link: "/operation/provider",
        alwaysOnSidebar: true,
      },
      {
        label: "Approved Fund List",
        linkId: "O14",
        link: "/operation/approvalFundList",
      },
      {
        label: "Investment Transaction",
        linkId: "M47",
        link: "/management/investmentTransactionSetting",
      },
      {
        label: "Provider Email Purposes",
        linkId: "M58",
        link: "/management/providerEmailPurposeSetting",
      },
    ],
  },
  {
    label: "Client",
    items: [
      {
        label: "Risk Control",
        linkId: "M46",
        link: "/management/riskControlSetting",
      },
    ],
  },
  {
    label: "User",
    items: [
      {
        label: "User",
        linkId: "O7",
        link: "/operation/user",
        alwaysOnSidebar: true,
      },
      { label: "User Role", linkId: "O17", link: "/operation/userRole" },
      { label: "User Group", linkId: "O8", link: "/operation/userGroup" },
      {
        label: "Departments",
        linkId: "EX2",
        link: "/management/department",
        alwaysOnSidebar: true,
      },
    ],
  },
  {
    label: "Commissions",
    items: [
      {
        label: "Overriding Plan",
        linkId: "M14",
        link: "/management/commissionOverridingPlan",
      },
      {
        label: "Commission Schedule",
        linkId: "M190",
        link: "/management/commissionSchedule",
      },
      { label: "Teams", linkId: "M106", link: "/management/team" },
      {
        label: "Allowance Plan",
        linkId: "M2",
        link: "/management/allowancePlan",
      },
      { label: "Exchange Rates", linkId: "M15", link: "/management/exchangeRate" },
    ],
  },
  {
    label: PROMOTION_SIDEBAR_SECTION,
    items: [
      { label: "Point Types", linkId: "M38", link: "/management/pointType" },
      {
        label: "Point Transactions",
        linkId: "M39",
        link: "/management/pointTransaction",
      },
      { label: "Level", linkId: "M40", link: "/management/levelType" },
      {
        label: "Promotion Tracks",
        linkId: "M41",
        link: "/management/promotionTrack",
      },
    ],
  },
  {
    label: "AI",
    items: [
      { label: "AI Prompts", linkId: "M192", link: "/management/aiPrompt" },
      { label: "AI Workflow", linkId: "M193", link: "/management/aiWorkflow" },
      {
        label: "MBID AI OCR",
        linkId: "M195",
        link: "/management/ocrAiSetting",
        alwaysOnSettings: true,
      },
    ],
  },
  {
    label: "Account",
    items: [
      { label: "HSBC MRI", linkId: "M49", link: "/account/hsbcMriSetting" },
      { label: "IR56M", linkId: "M50", link: "/account/ir56mSetting" },
    ],
  },
  {
    label: "Email",
    items: [
      {
        label: "Integration Keys",
        linkId: "M60",
        link: "/management/integrationKeySetting",
        alwaysOnSettings: true,
      },
      {
        label: "Email SMTP Settings",
        linkId: "M55",
        link: "/management/emailSmtpSetting",
        alwaysOnSettings: true,
      },
      {
        label: "Email Send Log",
        linkId: "M57",
        link: "/management/emailSendLog",
        alwaysOnSettings: true,
      },
    ],
  },
  {
    label: "Company",
    items: [
      { label: "Organization", linkId: "M42", link: "/management/organization" },
      { label: "Companies", linkId: "M44", link: "/management/company" },
      {
        label: "Document Settings",
        linkId: "M43",
        link: "/management/documentSetting",
      },
      {
        label: "Auto Code",
        linkId: "M59",
        link: "/management/codeSetting",
        alwaysOnSettings: true,
      },
    ],
  },
  {
    label: "Records",
    items: [
      { label: "Extra Fields", linkId: "M36", link: "/management/extraFields" },
      { label: "Ticket Types", linkId: "M16", link: "/management/ticketTypes" },
      {
        label: "Order Services Types",
        linkId: "M25",
        link: "/management/orderServiceType",
      },
      {
        label: "Expense Types",
        linkId: "EX1",
        link: "/management/expenseType",
      },
    ],
  },
  {
    label: "Workflow",
    items: [
      {
        label: "Approval Process",
        linkId: "MCA1",
        link: "/management/mcaProcess",
        alwaysOnSidebar: true,
      },
      {
        label: "Notification Rules",
        linkId: "NTR1",
        link: "/management/notificationRules",
        alwaysOnSidebar: true,
      },
      {
        label: "Notification Logs",
        linkId: "M53",
        link: "/management/notificationLogs",
      },
    ],
  },
  {
    label: "System",
    items: [
      {
        label: "Data Migration",
        linkId: "M45",
        link: "/management/dataMigration",
      },
      {
        label: "File Backup Sync",
        linkId: "M48",
        link: "/operation/fileBackupSyncSetting",
      },
      { label: "API Keys", linkId: "M51", link: "/management/apiKey" },
      { label: "Cron Jobs", linkId: "M52", link: "/management/cronJob" },
    ],
  },
];

export function getSettingSidebarSections(promotionModuleEnabled) {
  if (promotionModuleEnabled) return SETTING_SIDEBAR_SECTIONS;
  return SETTING_SIDEBAR_SECTIONS.filter(
    (section) => section.label !== PROMOTION_SIDEBAR_SECTION
  );
}

export function getPinnableSettingLinkIds(promotionModuleEnabled = true) {
  return getSettingSidebarSections(promotionModuleEnabled)
    .flatMap((section) => section.items)
    .map((item) => item.linkId);
}

export function findSettingItemByPath(path) {
  return SETTING_SIDEBAR_SECTIONS.flatMap((section) => section.items).find(
    (item) => item.link === path
  );
}
